import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ProfileMenu from '@common/components/ProfileMenu';
import AddressCard from '@pages/Cart/view/components/AddressCard';
import {
    TextField,
    Grid,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from '@mui/material';
import CustomRadio from '@common/components/CustomRadio';
import { addAddress, getAddresses, makeAddDefault, removeAddress, updateAddress } from '@common/utils/cart';
import { useFormik } from "formik"
import * as Yup from "yup"

const shippingAddressListData = [
    {
        id: 1,
        name: 'Shashank Yeole',
        type: 'home',
        address: 'Kanakia zen world , kanjurmarg west, near station road, Kanjurmarg, Mumbai - maharashtra - 400032',
        groupName: 'shippingAddress',
        defaultAddress: true,
    },
    {
        id: 2,
        name: 'Rakesh',
        type: 'other',
        address: 'Kanakia zen world , kanjurmarg west, near station road, Kanjurmarg, Mumbai - maharashtra - 400032',
        groupName: 'shippingAddress',
        defaultAddress: false,
    }
]

const stateOptions = [
    { value: 'andhra_pradesh', label: 'Andhra Pradesh' },
    { value: 'arunachal_pradesh', label: 'Arunachal Pradesh' },
    { value: 'assam', label: 'Assam' },
    { value: 'bihar', label: 'Bihar' },
    { value: 'chhattisgarh', label: 'Chhattisgarh' },
    { value: 'goa', label: 'Goa' },
    { value: 'gujarat', label: 'Gujarat' },
    { value: 'haryana', label: 'Haryana' },
    { value: 'himachal_pradesh', label: 'Himachal Pradesh' },
    { value: 'jharkhand', label: 'Jharkhand' },
    { value: 'karnataka', label: 'Karnataka' },
    { value: 'kerala', label: 'Kerala' },
    { value: 'madhya_pradesh', label: 'Madhya Pradesh' },
    { value: 'maharashtra', label: 'Maharashtra' },
    { value: 'manipur', label: 'Manipur' },
    { value: 'meghalaya', label: 'Meghalaya' },
    { value: 'mizoram', label: 'Mizoram' },
    { value: 'nagaland', label: 'Nagaland' },
    { value: 'odisha', label: 'Odisha' },
    { value: 'punjab', label: 'Punjab' },
    { value: 'rajasthan', label: 'Rajasthan' },
    { value: 'sikkim', label: 'Sikkim' },
    { value: 'tamil_nadu', label: 'Tamil Nadu' },
    { value: 'telangana', label: 'Telangana' },
    { value: 'tripura', label: 'Tripura' },
    { value: 'uttar_pradesh', label: 'Uttar Pradesh' },
    { value: 'uttarakhand', label: 'Uttarakhand' },
    { value: 'west_bengal', label: 'West Bengal' },
    { value: 'andaman_nicobar', label: 'Andaman and Nicobar Islands' },
    { value: 'chandigarh', label: 'Chandigarh' },
    { value: 'dadra_nagar_haveli_daman_diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'lakshadweep', label: 'Lakshadweep' },
    { value: 'puducherry', label: 'Puducherry' },
    { value: 'jammu_kashmir', label: 'Jammu and Kashmir' },
    { value: 'ladakh', label: 'Ladakh' }
];

function Addressess() {

    const [addressData, setAddressData] = useState([])
    const [editState, setEditState] = useState(false)
    const [addressType, setAddressType] = useState("")
    const [addressId, setAddressId] = useState(null)
    useEffect(() => {
        fetchAddresses()
    }, [])

    const fetchAddresses = async () => {
        try {
            const addresses = await getAddresses() // Await the promise returned by getCart
            if (addresses) {
                setAddressData(addresses?.data)
            }
        } catch (error) {
            console.error("Error fetching address:", error)
        }
    }

    const editHandleChange = (id, type = "new") => {
        const storedAddresses = JSON.parse(localStorage.getItem("addresses")) || []
        const addressToEdit = storedAddresses.find((address) => address.id === id)
        setAddressType(type)
        if (addressToEdit) {
            setAddressId(id)
            formik.setValues({
                firstName: addressToEdit.firstName || "",
                lastName: addressToEdit.lastName || "",
                phone: addressToEdit.phone || "",
                email: addressToEdit.email || "",
                address: addressToEdit.address || "",
                landmark: addressToEdit.landmark || "",
                city: addressToEdit.city || "",
                state: addressToEdit.state || "",
                pincode: addressToEdit.pincode || "",
                tag: addressToEdit.tag || "home",
                isDefault: addressToEdit.isDefault || false,
            })
        } else {
            console.error("Address not found for the given ID")
        }
        setEditState(true)
    }

    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            address: "",
            landmark: "",
            city: "",
            state: "",
            pincode: "",
            tag: "home", // Default value for "Save Address As"
            isDefault: false,
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("First name is required"),
            lastName: Yup.string().required("Last name is required"),
            phone: Yup.string()
                .required("Mobile number is required")
                .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
            email: Yup.string().email("Invalid email address"),
            address: Yup.string().required("Full address is required"),
            landmark: Yup.string().required("Locality is required"),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            pincode: Yup.string()
                .required("Pincode is required")
                .matches(/^[0-9]{6}$/, "Pincode must be 6 digits"),
            tag: Yup.string().required("Address type is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                // console.log('Form Values:', values);
                let response
                if (addressType === "update") {
                    response = await updateAddress(values, addressId) // Call the API to add the address
                } else {
                    response = await addAddress(values) // Call the API to add the address
                }
                // console.log('Address added successfully:', response);
                if (response) {
                    fetchAddresses() // Fetch updated addresses after successful submission
                    resetForm() // Reset the form after successful submission
                    setEditState(false) // Close the form
                }
            } catch (error) {
                console.error("Error adding address:", error)
            }
        },
    })

    const handleChangeDefaultAddress = async (id) => {
        const response = await makeAddDefault(id)
        if (response) {
            fetchAddresses() // Fetch updated addresses after successful submission
        }
    }

    const handleRemoveAddress = async (id) => {
        const response = await removeAddress(id)
        if (response) {
            fetchAddresses() // Fetch updated addresses after successful submission
        }
    }
    return (
        <div className='bs-section'>
            <div className='lyt-profile'>
                <div className='lyt-profile__header'>
                    <Link className='lyt-profile__title'>
                        <span className='icon icon-o-left lyt-profile__title-icon'></span>
                        <span className='lyt-profile__title-text'>your profile</span>
                    </Link>
                </div>
                <div className='lyt-profile__body'>
                    <ProfileMenu data={JSON.parse(localStorage.getItem('u_info'))} />
                    <div className='lyt-profile__cont-wrap'>
                        <div className='lyt-manage-address'>
                            <ul className='lyt-manage-address__wrap'>
                                {!editState ? (
                                    <li className='lyt-manage-address__section-item'>
                                        <div className='lyt-manage-address__title-wrap'>
                                            <h2 className='lyt-manage-address__title'>
                                                <span className='icon icon lyt-manage-address__title-icon'></span>
                                                <span className='lyt-manage-address__title-text'>manage address</span>
                                            </h2>
                                        </div>
                                        <div className='lyt-manage-address__cont-wrap'>
                                            <ul className='lyt-adress'>
                                                {addressData.map((item, index) => {
                                                    return (
                                                        <li className="lyt-adress__item" key={index}>
                                                            <AddressCard
                                                                id={item?.id}
                                                                name={`${item?.firstName} ${item?.lastName}` || ""}
                                                                address={item?.address}
                                                                type={item?.tag}
                                                                groupName={"shippingAddress"}
                                                                index={index}
                                                                isDefault={item?.isDefault}
                                                                variant={'no-radio'}
                                                                onClick={() => editHandleChange(item?.id, "update")}
                                                                handleChangeDefaultAddress={handleChangeDefaultAddress}
                                                                onRemove={handleRemoveAddress}
                                                            />
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                            <button className='bs-btn bs-btn__btn-border bs-btn__btn-border--typ-rounded-box bs-form__action-btn' onClick={editHandleChange}>
                                                <span className='bs-btn__icon icon icon-increment'></span>
                                                <span className='bs-btn__btn-text'>add new address</span>
                                            </button>
                                        </div>
                                    </li>
                                ) : (
                                    <li className='lyt-manage-address__section-item'>
                                        <div className='lyt-manage-address__title-wrap'>
                                            <h2 className='lyt-manage-address__title'>
                                                <span className='icon icon-home lyt-manage-address__title-icon'></span>
                                                <span className='lyt-manage-address__title-text'>add new address</span>
                                            </h2>
                                        </div>
                                        <div className='lyt-manage-address__cont-wrap'>
                                            <form className="bs-form bs-form--typ-column" onSubmit={formik.handleSubmit}>
                                                <Grid container columnSpacing={4.8} rowSpacing={3.2}>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="firstName"
                                                            name="firstName"
                                                            label="First Name"
                                                            value={formik.values.firstName}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                                            helperText={formik.touched.firstName && formik.errors.firstName}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="lastName"
                                                            name="lastName"
                                                            label="Last Name"
                                                            value={formik.values.lastName}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                                            helperText={formik.touched.lastName && formik.errors.lastName}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="phone"
                                                            name="phone"
                                                            label="Mobile Number"
                                                            value={formik.values.phone}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                                                            helperText={formik.touched.phone && formik.errors.phone}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="email"
                                                            name="email"
                                                            label="Email ID"
                                                            value={formik.values.email}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.email && Boolean(formik.errors.email)}
                                                            helperText={formik.touched.email && formik.errors.email}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <TextField
                                                            id="address"
                                                            name="address"
                                                            label="Full Address"
                                                            value={formik.values.address}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.address && Boolean(formik.errors.address)}
                                                            helperText={formik.touched.address && formik.errors.address}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="landmark"
                                                            name="landmark"
                                                            label="Locality / Town"
                                                            value={formik.values.landmark}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.landmark && Boolean(formik.errors.landmark)}
                                                            helperText={formik.touched.landmark && formik.errors.landmark}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="city"
                                                            name="city"
                                                            label="City"
                                                            value={formik.values.city}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.city && Boolean(formik.errors.city)}
                                                            helperText={formik.touched.city && formik.errors.city}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="state">State</InputLabel>
                                                            <Select
                                                                labelId="state"
                                                                id="state"
                                                                name="state"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.state}
                                                                label="state"
                                                                IconComponent={(props) => (
                                                                    <span
                                                                        {...props}
                                                                        className={`icon icon-angle-down ${props.className}`}
                                                                    ></span>
                                                                )}
                                                                MenuProps={{
                                                                    classes: {
                                                                        paper: "bs-menu-dropdown",
                                                                    },
                                                                }}
                                                            >
                                                                {stateOptions.map((item, index) => {
                                                                    return <MenuItem value={item.value} key={index}>{item.label}</MenuItem>
                                                                })}
                                                            </Select>
                                                            {formik.touched.state && formik.errors.state ? (
                                                                <div className='bs-form__error-text'>{formik.errors.state}</div>
                                                            ) : null}
                                                        </FormControl>
                                                        {/* <TextField
                                                            id="state"
                                                            name="state"
                                                            label="State"
                                                            value={formik.values.state}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.state && Boolean(formik.errors.state)}
                                                            helperText={formik.touched.state && formik.errors.state}
                                                            fullWidth
                                                        /> */}
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            id="pincode"
                                                            name="pincode"
                                                            label="Pincode"
                                                            value={formik.values.pincode}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                                                            helperText={formik.touched.pincode && formik.errors.pincode}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item ms={12} xs={12} container spacing={3} className="bs-form__selection-action-wrap">
                                                        <Grid item xs={12} md={6}>
                                                            <div className="bs-form__form-group">
                                                                <label className="bs-form__field-label">Save Address As</label>
                                                                <ul className="lyt-radio-list">
                                                                    {["home", "work", "other"].map((type, index) => (
                                                                        <li className="lyt-radio-list__item" key={index}>
                                                                            <CustomRadio
                                                                                title={type}
                                                                                groupName="tag"
                                                                                itemId={`tag__${type}`}
                                                                                variant="capsule"
                                                                                defaultValue={formik.values.tag}
                                                                                onChange={() => formik.setFieldValue("tag", type)}
                                                                            />
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12} md={6} className="cm-align-bottom-end">
                                                            <div className="bs-checkbox bs-detail-info__accept-coupon">
                                                                <input
                                                                    type="checkbox"
                                                                    id="isDefault"
                                                                    name="isDefault"
                                                                    checked={formik.values.isDefault}
                                                                    onChange={formik.handleChange}
                                                                />
                                                                <label
                                                                    className="bs-checkbox__label bs-detail-info__accept-coupon-label"
                                                                    htmlFor="isDefault"
                                                                >
                                                                    Make this as Default Address
                                                                </label>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} md={12} container spacing={3}>
                                                        <Grid item xs={12} md={6}>
                                                            <button type="button" className="bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border" onClick={() => setEditState(false)}>
                                                                Back
                                                            </button>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <button type="submit" className="bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl">
                                                                Submit
                                                            </button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </div>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Addressess